import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SCROLL_GROUP_DATA_KEY } from './scroll-position.service';

import { AccountSettingsComponent } from './components/account-settings/account-settings.component';

import { CustomersComponent } from './components/customers/customers.component';
import { CustomerDetailComponent } from './components/customers/customer-detail/customer-detail.component';
import { UserListComponent } from './components/admin/user-list/user-list.component';
import { UserComponent } from './components/admin/user-list/user/user.component';
import { EventsComponent } from './components/events/events.component';
import { EventsListComponent } from './components/events/scheduled-events/events-list/events-list.component';
import { EventTypesListComponent } from './components/events/event-setup/event-types-list/event-types-list.component';
import { ScheduledEventsComponent } from './components/events/scheduled-events/scheduled-events.component';
import { EventSetupComponent } from './components/events/event-setup/event-setup.component';
import { EventTypeEditComponent } from './components/events/event-setup/event-type-edit/event-type-edit.component';
import { EventTypeSchedulesComponent } from './components/events/event-setup/event-type-schedules/event-type-schedules.component';
import { EventTypeQuestionsComponent } from './components/events/event-setup/event-type-questions/event-type-questions.component';
import { EventSettingsComponent } from './components/events/event-settings/event-settings.component';
import {
  EventTypeCancellationPolicyComponent
} from './components/events/event-setup/event-type-cancellation-policy/event-type-cancellation-policy.component';
import {
  CreditsAndVouchersSubListComponent
} from './components/customers/customer-detail/sub-lists/credits-and-vouchers-sub-list/credits-and-vouchers-sub-list.component';
import {
  MembershipsAndPassesSubListComponent
} from './components/customers/customer-detail/sub-lists/memberships-and-passes-sub-list/memberships-and-passes-sub-list.component';
import { CheckInsSubListComponent } from './components/customers/customer-detail/sub-lists/check-ins-sub-list/check-ins-sub-list.component';
import { BulkAddCreditOrVoucherComponent } from './components/customers/bulk-add-credit-or-voucher/bulk-add-credit-or-voucher.component';
import { DocumentTemplatesComponent } from './components/admin/document-templates/document-templates.component';
import { DocumentTemplateEditComponent } from './components/admin/document-templates/document-template-edit/document-template-edit.component';

import { DocumentTemplateAddComponent } from './components/admin/document-templates/document-template-add/document-template-add.component';
import { DocumentPoliciesComponent } from './components/admin/document-templates/document-policies/document-policies.component';
import {
  DocumentPolicyAddComponent
} from './components/admin/document-templates/document-policies/document-policy-add/document-policy-add.component';
import {
  DocumentPolicyEditComponent
} from './components/admin/document-templates/document-policies/document-policy-edit/document-policy-edit.component';
import {
  CustomerProfileLayoutComponent
} from './components/admin/customer-profile-config/customer-profile-layout/customer-profile-layout.component';
import { EditCustomerProfileComponent } from './components/customers/customer-detail/edit-customer-profile/edit-customer-profile.component';
import { LinkingAccountsConfigComponent } from './components/admin/linking-accounts-config/linking-accounts-config.component';
import { InboxComponent } from './components/inbox/inbox.component';
import { InboxCustomersComponent } from './components/inbox/inbox-customers/inbox-customers.component';
import {
  InboxLinkingAccountRequestsComponent
} from './components/inbox/inbox-customers/inbox-linking-account-requests/inbox-linking-account-requests.component';
import { TaxRatesConfigComponent } from './components/admin/tax-rates-config/tax-rates-config.component';
import { MembershipsComponent } from './components/admin/memberships/memberships.component';
import { MembershipDetailComponent } from './components/admin/memberships/membership-detail/membership-detail.component';
import { EntryPassDetailComponent } from './components/admin/memberships/entry-pass-detail/entry-pass-detail.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CheckInComponent } from './components/check-in/check-in.component';
import { OrganizationSettingsComponent } from './components/admin/organization-settings/organization-settings.component';
import { PaymentsSubListComponent } from './components/customers/customer-detail/sub-lists/payments-sub-list/payments-sub-list.component';
import { PurchasesSubListComponent } from './components/customers/customer-detail/sub-lists/purchases-sub-list/purchases-sub-list.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { ProficienciesConfigComponent } from './components/admin/proficiencies-config/proficiencies-config.component';
import { CheckInSoundsConfigComponent } from './components/admin/check-in-sounds-config/check-in-sounds-config.component';
import {
  ReservationsSubListComponent
} from './components/customers/customer-detail/sub-lists/reservations-sub-list/reservations-sub-list.component';
import {
  UpcomingReservationsSubListComponent
} from './components/customers/customer-detail/sub-lists/upcoming-reservations-sub-list/upcoming-reservations-sub-list.component';
import {
  CustomerBookingsSubListComponent
} from './components/customers/customer-detail/sub-lists/customer-bookings-sub-list/customer-bookings-sub-list.component';
import { MergeCustomersComponent } from './components/customers/merge-customers/merge-customers.component';
import { LocationAreasConfigComponent } from './components/admin/location-areas-config/location-areas-config.component';
import {
  InboxInvalidDocumentsComponent
} from './components/inbox/inbox-customers/inbox-invalid-documents/inbox-invalid-documents.component';
import { EventCalendarComponent } from './components/events/scheduled-events/event-calendar/event-calendar.component';
import {
  ManageBookingCancellationAndRefundComponent
} from './components/events/scheduled-events/booking-cancel/manage-booking-cancellation-and-refund.component';
import {
  EventTypePricingMatricesComponent
} from './components/events/event-setup/event-type-pricing-matrices/event-type-pricing-matrices.component';
import {
  EventTypePricingMatrixEditComponent
// tslint:disable-next-line:max-line-length
} from './components/events/event-setup/event-type-pricing-matrices/event-type-pricing-matrix-edit/event-type-pricing-matrix-edit.component';
import {
  InboxDocumentsPendingStaffApprovalComponent
} from './components/inbox/inbox-customers/inbox-documents-pending-staff-approval/inbox-documents-pending-staff-approval.component';
import { ConfigureAccountingConnectionComponent } from './components/admin/accounting-connections/configure-accounting-connection/configure-accounting-connection.component';
import {
  EventTypeEditScheduleComponent
} from './components/events/event-setup/event-type-schedules/event-type-edit-schedule/event-type-edit-schedule.component';
import {
  EventTypeScheduleExceptionsComponent
} from './components/events/event-setup/event-type-schedule-exceptions/event-type-schedule-exceptions.component';
import {
  EventTypeEditScheduleExceptionComponent
// tslint:disable-next-line:max-line-length
} from './components/events/event-setup/event-type-schedule-exceptions/event-type-edit-schedule-exception/event-type-edit-schedule-exception.component';
import { TimeTrackingConfigComponent } from './components/admin/time-tracking-config/time-tracking-config.component';
import {
  CustomerActivityLogSubListComponent
} from './components/customers/customer-detail/sub-lists/activity-log-sub-list/customer-activity-log-sub-list.component';
import {
  CustomerEmailsSubListComponent
} from './components/customers/customer-detail/sub-lists/emails-sub-list/customer-emails-sub-list.component';
import {
  PrivateEventEditEventComponent
} from './components/events/scheduled-events/private-events/private-event-edit-event/private-event-edit-event.component';
import {
  PrivateEventEditReservationsComponent
} from './components/events/scheduled-events/private-events/private-event-edit-reservations/private-event-edit-reservations.component';
import {
  PrivateEventEditPaymentComponent
} from './components/events/scheduled-events/private-events/private-event-edit-payment/private-event-edit-payment.component';
import { EventTypeEmailsComponent } from './components/events/event-setup/event-type-emails/event-type-emails.component';
import {
  InboxUnlinkedEntryPassesComponent
} from './components/inbox/inbox-memberships-and-passes/inbox-unlinked-entry-passes/inbox-unlinked-entry-passes.component';
import {
  InboxUnlinkedMembershipsComponent
} from './components/inbox/inbox-memberships-and-passes/inbox-unlinked-memberships/inbox-unlinked-memberships.component';
import { BulkCreateBookingComponent } from './components/customers/bulk-create-booking/bulk-create-booking.component';
import { InboxMembershipsAndPassesComponent } from './components/inbox/inbox-memberships-and-passes/inbox-memberships-and-passes.component';
import {
  InboxMembershipsPendingStaffApprovalComponent
// tslint:disable-next-line:max-line-length
} from './components/inbox/inbox-memberships-and-passes/inbox-memberships-pending-staff-approval/inbox-memberships-pending-staff-approval.component';
import { LocationSettingsComponent } from './components/admin/location-settings/location-settings.component';
import {
  MembershipCancellationReasonSettingsComponent
} from './components/admin/memberships/membership-cancellation-reason-settings/membership-cancellation-reason-settings.component';
import { MembershipFreezeReasonSettingsComponent } from './components/admin/memberships/membership-freeze-reason-settings/membership-freeze-reason-settings.component';
import { ChallengesComponent } from './components/admin/challenges/challenges.component';
import { ChallengeDetailComponent } from './components/admin/challenges/challenge-detail/challenge-detail.component';
import { EntryPassDiscountsComponent } from './components/admin/memberships/entry-pass-discounts/entry-pass-discounts.component';
import { EntryPassDiscountDetailComponent } from './components/admin/memberships/entry-pass-discounts/entry-pass-discount-detail/entry-pass-discount-detail.component';
import { MembershipDiscountDetailComponent } from './components/admin/memberships/membership-discounts/membership-discount-detail/membership-discount-detail.component';
import { MembershipDiscountsComponent } from './components/admin/memberships/membership-discounts/membership-discounts.component';
import { EventDiscountsComponent } from './components/events/event-setup/event-discounts/event-discounts.component';
import { EventDiscountDetailComponent } from './components/events/event-setup/event-discounts/event-discount-detail/event-discount-detail.component';
import { AssociationsComponent } from './components/associations/associations.component';
import { AssociationProfileComponent } from './components/associations/association-profile/association-profile.component';
import { ConfigureAssociationComponent } from './components/associations/association-profile/configure-association/configure-association.component';
import { StripeReadersConfigComponent } from './components/admin/payment-processor-connections/configure-payment-processor-connection/stripe-readers-config/stripe-readers-config.component';
import { EventTypeCategoriesComponent } from './components/events/event-setup/event-type-categories/event-type-categories.component';
import { EventTypeCategoryDetailComponent } from './components/events/event-setup/event-type-categories/event-type-category-detail/event-type-category-detail.component';
import { AccountingConnectionsComponent } from './components/admin/accounting-connections/accounting-connections.component';
import { PaymentProcessorConnectionsComponent } from './components/admin/payment-processor-connections/payment-processor-connections.component';
import { ConfigurePaymentProcessorConnectionComponent } from './components/admin/payment-processor-connections/configure-payment-processor-connection/configure-payment-processor-connection.component';
import { InboxAssociationsComponent } from './components/inbox/inbox-associations/inbox-associations.component';
import { InboxAssociationJoinRequestsComponent } from './components/inbox/inbox-associations/inbox-association-join-requests/inbox-association-join-requests.component';
import { EventDetailComponent } from './components/events/scheduled-events/events-list/event-detail/event-detail.component';
import { EventTypeWaitlistConfigComponent } from './components/events/event-setup/event-type-waitlist-config/event-type-waitlist-config.component';
import { CustomerProfileConfigComponent } from './components/admin/customer-profile-config/customer-profile-config.component';
import { CustomCustomerFieldsConfigComponent } from './components/admin/customer-profile-config/custom-customer-fields-config/custom-customer-fields-config.component';
import { EventTypeScheduledEventsColumnsComponent } from './components/events/event-setup/event-type-scheduled-events-columns/event-type-scheduled-events-columns.component';
import { VoucherPacksComponent } from './components/events/event-setup/voucher-packs/voucher-packs.component';
import {
  VoucherPackDetailComponent
} from './components/events/event-setup/voucher-packs/voucher-pack-detail/voucher-pack-detail.component';
import { CapitanStaffGuard } from '../../capitan-staff-guard.service';
import { UnsavedChangesGuard } from '../../unsaved-changes-guard.service';
import { ClimberAppCustomizationSettingsComponent } from './components/admin/climber-app-customization-settings/climber-app-customization-settings.component';
import { AdminComponent } from './components/admin/admin.component';
import { OrgWideMembershipSettingsComponent } from './components/admin/memberships/org-wide-membership-settings/org-wide-membership-settings.component';
import { GiftingConfigComponent } from './components/admin/gifting-config/gifting-config.component';
import {
  MembershipGiftingConfigDetailComponent
} from './components/admin/gifting-config/membership-gifting-config-detail/membership-gifting-config-detail.component';
import {
  EntryPassGiftingConfigDetailComponent
} from './components/admin/gifting-config/entry-pass-gifting-config-detail/entry-pass-gifting-config-detail.component';
import {
  VoucherPackGiftingConfigDetailComponent
} from './components/admin/gifting-config/voucher-pack-gifting-config-detail/voucher-pack-gifting-config-detail.component';
import { GiftDiscountsComponent } from './components/admin/gifting-config/gift-discounts/gift-discounts.component';
import {
  MembershipGiftDiscountDetailComponent
} from './components/admin/gifting-config/gift-discounts/membership-gift-discount-detail/membership-gift-discount-detail.component';
import {
  EntryPassGiftDiscountDetailComponent
} from './components/admin/gifting-config/gift-discounts/entry-pass-gift-discount-detail/entry-pass-gift-discount-detail.component';
import {
  VoucherPackGiftDiscountDetailComponent
} from './components/admin/gifting-config/gift-discounts/voucher-pack-gift-discount-detail/voucher-pack-gift-discount-detail.component';
import { EventTypeWaitlistsComponent } from './components/events/scheduled-events/event-type-waitlists/event-type-waitlists.component';
import {
  EventTypeWaitlistEntriesComponent
} from './components/events/scheduled-events/event-type-waitlists/event-type-waitlist-entries/event-type-waitlist-entries.component';
import { WaitlistsComponent } from './components/events/scheduled-events/waitlists/waitlists.component';
import { EventWaitlistsComponent } from './components/events/scheduled-events/waitlists/event-waitlists/event-waitlists.component';
import { RostersComponent } from './components/events/scheduled-events/rosters/rosters.component';
import { EventTypeRostersComponent } from './components/events/event-setup/event-type-rosters/event-type-rosters.component';
import {
  EventTypeRosterEditComponent
} from './components/events/event-setup/event-type-rosters/event-type-roster-edit/event-type-roster-edit.component';
import {
  EventTypePricingMembershipComponent
} from './components/events/event-setup/event-type-pricing-membership/event-type-pricing-membership.component';
import {
  InboxPotentialDuplicateCustomersComponent
} from './components/inbox/inbox-customers/inbox-potential-duplicate-customers/inbox-potential-duplicate-customers.component';
import { RedemptionCodesComponent } from './components/admin/redemption-codes/redemption-codes.component';
import { RedemptionCodeSetComponent } from './components/admin/redemption-codes/redemption-code-set/redemption-code-set.component';
import { CustomInboxConfigComponent } from './components/admin/custom-inbox-config/custom-inbox-config.component';
import { CustomInboxEditComponent } from './components/admin/custom-inbox-config/custom-inbox-edit/custom-inbox-edit.component';
import { InboxCustomComponent } from './components/inbox/inbox-custom/inbox-custom.component';
import {
  ScheduledEventsDefaultRedirectComponent
} from './components/events/scheduled-events/scheduled-events-default-redirect/scheduled-events-default-redirect.component';
import { GiftPrintOptionsComponent } from './components/admin/gifting-config/gift-print-options/gift-print-options.component';
import {
  GiftCenterHomePageComponent
} from './components/admin/gifting-config/gift-center-home-page/gift-center-home-page.component';
import {
  GiftCardSalesConfigComponent
} from './components/admin/gifting-config/gift-card-sales-config/gift-card-sales-config.component';
import { SaleInitComponent } from './components/sale/sale-init/sale-init.component';
import {
  RecentlyActiveCustomersComponent
} from './components/recently-active-customers/recently-active-customers.component';
import {
  MembershipCategoriesComponent
} from './components/admin/memberships/membership-categories/membership-categories.component';
import {
  MembershipCategoryDetailComponent
} from './components/admin/memberships/membership-categories/membership-category-detail/membership-category-detail.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'reporting/customer-check-in-counts-in-date-range',
    component: CustomersComponent,
    data: {displayCheckInRangeCount: true}
  },
  {
    path: 'reporting',
    loadChildren: () =>
      import(
        './modules/reporting/reporting.module'
      ).then(
        m => m.ReportingModule
      )
  },
  {
    path: 'retail',
    canLoad: [CapitanStaffGuard],
    canActivate: [CapitanStaffGuard],
    loadChildren: () =>
      import(
        './modules/retail-mockups/retail-mockups.module'
      ).then(
        m => m.RetailMockupsModule
      )
  },
  {
    path: 'home',
    component: DashboardComponent
  },
  {
    path: 'check-in',
    component: CheckInComponent
  },
  {
    path: 'customer-profile-config',
    component: CustomerProfileConfigComponent,
    children: [
      {
        path: '',
        redirectTo: 'layout',
        pathMatch: 'full'
      },
      {
        path: 'layout',
        component: CustomerProfileLayoutComponent,
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: 'custom-fields',
        component: CustomCustomerFieldsConfigComponent
      }
    ]
  },
  {
    path: 'linking-accounts-config',
    component: LinkingAccountsConfigComponent
  },
  {
    path: 'tax-rates-config',
    component: TaxRatesConfigComponent
  },
  {
    path: 'areas-config',
    component: LocationAreasConfigComponent
  },
  {
    path: 'proficiencies-config',
    component: ProficienciesConfigComponent
  },
  {
    path: 'time-tracking-config',
    component: TimeTrackingConfigComponent
  },
  {
    path: 'check-in-sounds-config',
    component: CheckInSoundsConfigComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'customers',
    component: CustomersComponent
  },
  {
    path: 'customers/bulk/add-credit-or-voucher',
    component: BulkAddCreditOrVoucherComponent
  },
  {
    path: 'customers/bulk/create-booking',
    component: BulkCreateBookingComponent
  },
  {
    path: 'customers/merge-customers',
    component: MergeCustomersComponent
  },
  {
    path: 'customers/:id/edit-profile',
    component: EditCustomerProfileComponent
  },
  {
    path: 'customers/:id',
    component: CustomerDetailComponent,
    // Switching a profile's tabs keeps the reader's place; opening a DIFFERENT
    // customer scrolls to the top, since the group's identity includes the
    // :id. See ScrollPositionService.
    data: { [SCROLL_GROUP_DATA_KEY]: 'customer-profile' },
    children: [
      {
        path: '',
        redirectTo: 'check-ins',
        pathMatch: 'full'
      },
      {
        path: 'check-ins',
        component: CheckInsSubListComponent
      },
      {
        path: 'payments',
        component: PaymentsSubListComponent
      },
      {
        // PRO-1338: The Reservations tab hosts two views. The selected one is
        // a child route so it can be linked to and survives a refresh.
        path: 'reservations',
        component: ReservationsSubListComponent,
        children: [
          {
            path: '',
            redirectTo: 'upcoming',
            pathMatch: 'full'
          },
          {
            path: 'upcoming',
            component: UpcomingReservationsSubListComponent
          },
          {
            path: 'bookings',
            component: CustomerBookingsSubListComponent
          }
        ]
      },
      {
        path: 'memberships-and-passes',
        component: MembershipsAndPassesSubListComponent
      },
      {
        path: 'purchases',
        canActivate: [CapitanStaffGuard],
        component: PurchasesSubListComponent
      },
      {
        path: 'credits-and-vouchers',
        component: CreditsAndVouchersSubListComponent
      },
      {
        path: 'activity-log',
        component: CustomerActivityLogSubListComponent
      },
      {
        path: 'emails',
        component: CustomerEmailsSubListComponent
      }
    ]
  },
  {
    path: 'recently-active-customers',
    component: RecentlyActiveCustomersComponent,
  },
  {
    path: 'events',
    component: EventsComponent,
    children: [
      {
        path: '',
        redirectTo: 'scheduled',
        pathMatch: 'full'
      },
      {
        path: 'scheduled',
        component: ScheduledEventsComponent,
        children: [
          {
            path: '',
            component: ScheduledEventsDefaultRedirectComponent
          },
          {
            path: 'now',
            component: EventsListComponent,
            data: {timeFilter: 'now'}
          },
          {
            path: 'now/event/:eventPartId',
            component: EventDetailComponent
          },
          {
            path: 'now/event/:eventPartId/booking/:bookingId/:reservationId/manage-cancellation-and-refund',
            component: ManageBookingCancellationAndRefundComponent
          },
          {
            path: 'upcoming',
            component: EventsListComponent,
            data: {timeFilter: 'upcoming'}
          },
          {
            path: 'upcoming/:date',
            component: EventsListComponent,
            data: {timeFilter: 'upcoming'}
          },
          {
            path: 'upcoming/:date/event/:eventPartId',
            component: EventDetailComponent
          },
          {
            path: 'upcoming/:date/event/:eventPartId/booking/:bookingId/:reservationId/manage-cancellation-and-refund',
            component: ManageBookingCancellationAndRefundComponent
          },
          {
            path: 'past',
            component: EventsListComponent,
            data: {timeFilter: 'past'}
          },
          {
            path: 'past/:date',
            component: EventsListComponent,
            data: {timeFilter: 'past'}
          },
          {
            path: 'past/:date/event/:eventPartId',
            component: EventDetailComponent
          },
          {
            path: 'past/:date/event/:eventPartId/booking/:bookingId/:reservationId/manage-cancellation-and-refund',
            component: ManageBookingCancellationAndRefundComponent
          },
          {
            path: 'calendar',
            component: EventCalendarComponent
          },
          {
            path: 'private-event/add',
            component: PrivateEventEditEventComponent
          },
          {
            path: 'private-event/add-from-booking/:requestBookingId',
            component: PrivateEventEditEventComponent
          },
          {
            path: 'private-event/edit/:id/event-details',
            component: PrivateEventEditEventComponent
          },
          {
            path: 'private-event/edit/:id/reservations',
            component: PrivateEventEditReservationsComponent,
            canDeactivate: [UnsavedChangesGuard]
          },
          {
            path: 'private-event/edit/:id/payment',
            component: PrivateEventEditPaymentComponent
          },
          {
            path: 'waitlists',
            component: WaitlistsComponent,
            children: [
              {
                path: '',
                redirectTo: 'event-type',
                pathMatch: 'full'
              },
              {
                path: 'event-type',
                component: EventTypeWaitlistsComponent
              },
              {
                path: 'event-type/:id',
                component: EventTypeWaitlistEntriesComponent
              },
              {
                path: 'events',
                component: EventWaitlistsComponent
              },
            ]
          },
          {
            path: 'event-type-waitlists',
            redirectTo: 'waitlists/event-type',
            pathMatch: 'full'
          },
          {
            path: 'event-type-waitlists/:id',
            redirectTo: 'waitlists/event-type/:id'
          },
          {
            path: 'rosters',
            component: RostersComponent
          },
        ]
      },
      {
        path: 'setup',
        component: EventSetupComponent,
        children: [
          {
            path: '',
            redirectTo: 'event-types',
            pathMatch: 'prefix'
          },
          {
            path: 'event-types',
            component: EventTypesListComponent
          },
          {
            path: 'edit/:id/details',
            component: EventTypeEditComponent,
            canDeactivate: [UnsavedChangesGuard]
          },
          {
            path: 'edit/:id/pricing-matrices',
            component: EventTypePricingMatricesComponent
          },
          {
            path: 'edit/:eventTypeId/pricing-matrices/add',
            component: EventTypePricingMatrixEditComponent
          },
          {
            path: 'edit/:eventTypeId/pricing-matrices/:id',
            component: EventTypePricingMatrixEditComponent
          },
          {
            path: 'edit/:id/pricing-membership',
            component: EventTypePricingMembershipComponent,
            canDeactivate: [UnsavedChangesGuard]
          },
          {
            path: 'edit/:id/schedules',
            component: EventTypeSchedulesComponent
          },
          {
            path: 'edit/:eventTypeId/schedules/add',
            component: EventTypeEditScheduleComponent
          },
          {
            path: 'edit/:eventTypeId/schedules/:scheduleId',
            component: EventTypeEditScheduleComponent
          },
          {
            path: 'edit/:id/schedule-exceptions',
            component: EventTypeScheduleExceptionsComponent
          },
          {
            path: 'edit/:eventTypeId/schedule-exceptions/add',
            component: EventTypeEditScheduleExceptionComponent
          },
          {
            path: 'edit/:eventTypeId/schedule-exceptions/:scheduleExceptionId',
            component: EventTypeEditScheduleExceptionComponent
          },
          {
            path: 'edit/:id/questions',
            component: EventTypeQuestionsComponent
          },
          {
            path: 'edit/:id/columns',
            component: EventTypeScheduledEventsColumnsComponent
          },
          {
            path: 'edit/:id/emails',
            component: EventTypeEmailsComponent,
            canDeactivate: [UnsavedChangesGuard]
          },
          {
            path: 'edit/:id/cancellation-policy',
            component: EventTypeCancellationPolicyComponent
          },
          {
            path: 'edit/:id/waitlist',
            component: EventTypeWaitlistConfigComponent,
            canDeactivate: [UnsavedChangesGuard]
          },
          {
            path: 'edit/:id/rosters',
            component: EventTypeRostersComponent
          },
          {
            path: 'edit/:eventTypeId/rosters/add',
            component: EventTypeRosterEditComponent
          },
          {
            path: 'edit/:eventTypeId/rosters/:rosterId',
            component: EventTypeRosterEditComponent
          },
          {
            path: 'add',
            component: EventTypeEditComponent,
            canDeactivate: [UnsavedChangesGuard]
          },
          {
            path: 'discounts',
            component: EventDiscountsComponent
          },
          {
            path: 'categories',
            component: EventTypeCategoriesComponent
          },
          {
            path: 'voucher-packs',
            component: VoucherPacksComponent
          },
        ]
      },
      {
        path: 'settings',
        component: EventSettingsComponent
      }
    ]
  },
  {
    path: 'events/setup/discounts/add',
    component: EventDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'events/setup/discounts/:id',
    component: EventDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'events/setup/categories/add',
    component: EventTypeCategoryDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'events/setup/categories/:id',
    component: EventTypeCategoryDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'events/setup/voucher-packs/add',
    component: VoucherPackDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'events/setup/voucher-packs/:id',
    component: VoucherPackDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'payments',
    component: PaymentsComponent
  },
  {
    path: 'memberships-and-passes',
    component: MembershipsComponent
  },
  {
    path: 'memberships/add',
    component: MembershipDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'memberships/:id',
    component: MembershipDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'entry-passes/add',
    component: EntryPassDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'entry-passes/:id',
    component: EntryPassDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'membership-settings/cancellation-reason',
    component: MembershipCancellationReasonSettingsComponent
  },
  {
    path: 'membership-settings/freeze-reason',
    component: MembershipFreezeReasonSettingsComponent
  },
  {
    path: 'membership-settings/org-wide-policies',
    component: OrgWideMembershipSettingsComponent
  },
  {
    path: 'membership-settings/discounts',
    component: MembershipDiscountsComponent
  },
  {
    path: 'membership-settings/discounts/add',
    component: MembershipDiscountDetailComponent
  },
  {
    path: 'membership-settings/discounts/:id',
    component: MembershipDiscountDetailComponent
  },
  {
    path: 'membership-settings/categories',
    component: MembershipCategoriesComponent
  },
  {
    path: 'membership-settings/categories/add',
    component: MembershipCategoryDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'membership-settings/categories/:id',
    component: MembershipCategoryDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'entry-pass-settings/discounts',
    component: EntryPassDiscountsComponent
  },
  {
    path: 'entry-pass-settings/discounts/add',
    component: EntryPassDiscountDetailComponent
  },
  {
    path: 'entry-pass-settings/discounts/:id',
    component: EntryPassDiscountDetailComponent
  },
  {
    path: 'inbox',
    component: InboxComponent,
    children: [
      {
        path: '',
        redirectTo: 'customers',
        pathMatch: 'full'
      },
      {
        path: 'customers',
        component: InboxCustomersComponent,
        children: [
          {
            path: '',
            redirectTo: 'documents-pending-approval',
            pathMatch: 'full'
          },
          {
            path: 'documents-pending-approval',
            component: InboxDocumentsPendingStaffApprovalComponent
          },
          {
            path: 'linking-account-requests',
            component: InboxLinkingAccountRequestsComponent
          },
          {
            path: 'invalid-documents',
            component: InboxInvalidDocumentsComponent
          },
          {
            path: 'potential-duplicate-customers',
            component: InboxPotentialDuplicateCustomersComponent
          }
        ]
      },
      {
        path: 'memberships-and-passes',
        component: InboxMembershipsAndPassesComponent,
        children: [
          {
            path: '',
            redirectTo: 'memberships-pending-approval',
            pathMatch: 'full'
          },
          {
            path: 'memberships-pending-approval',
            component: InboxMembershipsPendingStaffApprovalComponent
          },
          {
            path: 'unlinked-memberships',
            component: InboxUnlinkedMembershipsComponent
          },
          {
            path: 'unlinked-entry-passes',
            component: InboxUnlinkedEntryPassesComponent
          }
        ]
      },
      {
        path: 'associations',
        component: InboxAssociationsComponent,
        children: [
          {
            path: '',
            redirectTo: 'join-requests',
            pathMatch: 'full'
          },
          {
            path: 'join-requests',
            component: InboxAssociationJoinRequestsComponent
          }
        ]
      },
      {
        path: 'custom',
        component: InboxCustomComponent
      }
    ]
  },
  {
    path: 'account-settings',
    component: AccountSettingsComponent
  },
  {
    path: 'document-templates',
    component: DocumentTemplatesComponent
  },
  {
    path: 'document-templates/add',
    component: DocumentTemplateAddComponent
  },
  {
    path: 'document-templates/:id',
    component: DocumentTemplateEditComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'document-templates/:id/settings',
    component: DocumentTemplateEditComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'document-templates/:id/content',
    component: DocumentTemplateEditComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'document-policies',
    component: DocumentPoliciesComponent
  },
  {
    path: 'document-policies/add',
    component: DocumentPolicyAddComponent
  },
  {
    path: 'document-policies/:id',
    component: DocumentPolicyEditComponent
  },
  {
    path: 'organization-settings',
    component: OrganizationSettingsComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'location-settings',
    component: LocationSettingsComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'climber-app-customization',
    component: ClimberAppCustomizationSettingsComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'accounting-connections',
    component: AccountingConnectionsComponent
  },
  {
    path: 'accounting-connections/configure/:id',
    component: ConfigureAccountingConnectionComponent
  },
  {
    path: 'payment-processor-connections',
    component: PaymentProcessorConnectionsComponent
  },
  {
    path: 'payment-processor-connections/configure/:id',
    component: ConfigurePaymentProcessorConnectionComponent
  },
  {
    path: 'payment-processor-connections/configure/:id/payment-terminals',
    component: StripeReadersConfigComponent
  },
  {
    path: 'users',
    component: UserListComponent
  },
  {
    path: 'users/add',
    component: UserComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'users/:id',
    component: UserComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'challenges',
    component: ChallengesComponent
  },
  {
    path: 'challenges/add',
    component: ChallengeDetailComponent
  },
  {
    path: 'challenges/:id',
    component: ChallengeDetailComponent
  },
  {
    path: 'associations',
    component: AssociationsComponent
  },
  {
    path: 'associations/:id',
    component: AssociationProfileComponent
  },
  {
    path: 'associations/:id/configure',
    component: ConfigureAssociationComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'admin',
    component: AdminComponent
  },
  {
    path: 'admin/custom-inboxes',
    component: CustomInboxConfigComponent
  },
  {
    path: 'admin/custom-inboxes/add',
    component: CustomInboxEditComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'admin/custom-inboxes/edit/:id',
    component: CustomInboxEditComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config',
    component: GiftingConfigComponent
  },
  {
    path: 'gifting-config/membership-gift-configs/add',
    component: MembershipGiftingConfigDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/membership-gift-configs/:id',
    component: MembershipGiftingConfigDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/entry-pass-gift-configs/add',
    component: EntryPassGiftingConfigDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/entry-pass-gift-configs/:id',
    component: EntryPassGiftingConfigDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/voucher-pack-gift-configs/add',
    component: VoucherPackGiftingConfigDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/voucher-pack-gift-configs/:id',
    component: VoucherPackGiftingConfigDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/discounts',
    component: GiftDiscountsComponent
  },
  {
    path: 'gifting-config/discounts/membership/add',
    component: MembershipGiftDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/discounts/membership/:id',
    component: MembershipGiftDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/discounts/entry-pass/add',
    component: EntryPassGiftDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/discounts/entry-pass/:id',
    component: EntryPassGiftDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/discounts/voucher-pack/add',
    component: VoucherPackGiftDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/discounts/voucher-pack/:id',
    component: VoucherPackGiftDiscountDetailComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/home-page',
    component: GiftCenterHomePageComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'gifting-config/print-options',
    component: GiftPrintOptionsComponent
  },
  {
    path: 'gifting-config/gift-card-config',
    component: GiftCardSalesConfigComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'redemption-codes',
    component: RedemptionCodesComponent
  },
  {
    path: 'redemption-codes/:id',
    component: RedemptionCodeSetComponent
  },
  {
    path: 'sale',
    component: SaleInitComponent
  },
  {
    path: 'sale/:id',
    component: SaleInitComponent
  },
  // Redirect any invalid URLs to home. This must be the last item in the list.
  {
    path: '**',
    redirectTo: 'home'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    relativeLinkResolution: 'legacy',
    // Disabled so that ScrollPositionService, not RouterScroller, consumes
    // the router's Scroll events.
    scrollPositionRestoration: 'disabled'
  })],
  exports: [RouterModule]
})
export class StaffSiteRoutingModule { }
